import { render, staticRenderFns } from "./imageUpload.vue?vue&type=template&id=dab2874a&scoped=true&"
import script from "./imageUpload.vue?vue&type=script&lang=js&"
export * from "./imageUpload.vue?vue&type=script&lang=js&"
import style0 from "./imageUpload.vue?vue&type=style&index=0&id=dab2874a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dab2874a",
  null
  
)

export default component.exports